import { gql } from '@apollo/client'
import { ORDER_SUBSCRIPTION_FIELDS, BILTY_OPS_FIELDS, JOBS_SUBSCRIPTION_FIELD } from './fragments'

export const BILTY_OPS_UPDATED = gql`
	${BILTY_OPS_FIELDS}
	subscription BiltyOpsUpdated {
		biltyOpsUpdated {
			...BiltyOpsFields
		}
	}
`
export const SUBSCRIBE_ORDERS = gql`
	${ORDER_SUBSCRIPTION_FIELDS}
	subscription OrderUpdatedByChildOrderStatusAndType($statuses: [String!]!, $type: String!) {
		OrderUpdatedByChildOrderStatusAndType(statuses: $statuses, type: $type) {
			...OrderSubscriptionFields
		}
	}
`

export const SUBSCRIBE_JOBS = gql`
	${JOBS_SUBSCRIPTION_FIELD}
	subscription JobUpdatedByMovementTypeAndStatus($movementType: [String!]!, $status: [String!]!, $subMovementType: [String!]!) {
		jobUpdatedByMovementTypeAndStatus(movementType: $movementType, status: $status, subMovementType: $subMovementType) {
			...JobSubscriptionFields
		}
	}
`
